import React from 'react';
import html2pdf from 'html2pdf.js';
import { makeStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import Typography from 'components/CncUI/Typography';
import Button from 'components/CncUI/Button';

import resultsNotFound from 'images/resultsNotFound.png';
import parseProfileData from './utils/parseProfileData';
import InfoBox from './InfoBox';

const useStyles = makeStyles(({ breakpoints }) => ({
  root: {
    [breakpoints.up('lg')]: {
      padding: 40,
    },
    [breakpoints.only('sm')]: {
      padding: 8,
    },
    [breakpoints.only('md')]: {
      padding: 16,
    },
  },
  notFound: {
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: 100,
  },
  header: {
    textAlign: 'center',
    [breakpoints.up('md')]: {
      textAlign: 'left',
    },
  },
  downloadButton: {
    textAlign: 'center',
    [breakpoints.up('md')]: {
      textAlign: 'right',
    },
  },
}));

const Details = props => {
  const classes = useStyles();
  const { loading, notFound = false } = props;
  const { profile, mappingOptions } = props;
  const { firstName, middleInitial, lastName } =
    (profile || {}).basicInfo || {};
  const fullName = [firstName, middleInitial, lastName]
    .filter(Boolean)
    .join(' ');

  if (loading) {
    return null;
  }

  if (notFound) {
    return (
      <img
        src={resultsNotFound}
        alt="Results not found"
        className={classes.notFound}
        id={'ResultsNotFoundImage'}
      />
    );
  }

  const data = parseProfileData(profile, mappingOptions);

  const downloadFile = () => {
    const options = {
      margin: 0.3,
      filename: `${fullName.replace(/ /g, '_')}_Profile.pdf`,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'in', format: 'letter' },
    };
    const element = document.getElementById('EmployeeLookup-PrintArea');
    html2pdf(element, options);
  };

  return (
    profile && (
      <Grid container spacing={1} className={classes.root}>
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6} className={classes.header}>
              <Typography variant="h4" id="DetailsFullName">
                {fullName}
              </Typography>
            </Grid>
            <Grid item xs={12} md={6} className={classes.downloadButton}>
              <Button secondary id="DownloadButton" onClick={downloadFile}>
                Download Profile Data
              </Button>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={2} id="EmployeeLookup-PrintArea">
            <InfoBox title="Basic Information" data={data.basicInfo} />
            <InfoBox title="Addresses" data={data.addresses} />
            <InfoBox title="Email Addresses" data={data.emails} />
            <InfoBox title="Phone Numbers" data={data.phones} />
            <InfoBox title="Direct Deposits" data={data.deposits} />
            <InfoBox title="Alternative Contacts" data={data.contacts} />
          </Grid>
        </Grid>
      </Grid>
    )
  );
};

export default Details;
